import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "px-5 md:px-3 mt-28" }
const _hoisted_2 = { class: "grid grid-cols-12 items-start gap-3" }
const _hoisted_3 = { class: "col-span-12 grid gap-y-3 mb-12" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "flex flex-col my-4 col-span-12 md:col-span-6" }
const _hoisted_7 = { class: "mb-2 text-black" }
const _hoisted_8 = { class: "flex flex-col my-4 col-span-12 md:col-span-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 text-black" }, "CNPJ", -1)
const _hoisted_10 = { class: "flex flex-col my-4 col-span-8 lg:col-span-5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 text-black" }, "CEP", -1)
const _hoisted_12 = { class: "flex flex-col my-4 col-span-4 lg:col-span-2" }
const _hoisted_13 = { class: "mb-2 text-black" }
const _hoisted_14 = { class: "flex flex-col my-4 col-span-12 lg:col-span-5" }
const _hoisted_15 = { class: "mb-2 text-black" }
const _hoisted_16 = { class: "flex flex-col my-4 col-span-9 md:col-span-6 lg:col-span-5" }
const _hoisted_17 = { class: "mb-2 text-black" }
const _hoisted_18 = { class: "flex flex-col my-4 col-span-3 md:col-span-6 lg:col-span-1" }
const _hoisted_19 = { class: "mb-2 text-black" }
const _hoisted_20 = { class: "flex flex-col my-4 col-span-12 md:col-span-6 lg:col-span-3" }
const _hoisted_21 = { class: "mb-2 text-black" }
const _hoisted_22 = { class: "flex flex-col my-4 col-span-12 md:col-span-6 lg:col-span-3" }
const _hoisted_23 = { class: "mb-2 text-black" }
const _hoisted_24 = { class: "col-span-12 bg-gray-200 p-4 mt-8 flex justify-between items-center rounded-md shadow-md" }
const _hoisted_25 = { class: "text-black" }
const _hoisted_26 = { class: "col-span-12 mb-4" }
const _hoisted_27 = { class: "text-black" }
const _hoisted_28 = { class: "col-span-12 lg:col-span-3" }
const _hoisted_29 = { class: "mb-2 text-black" }
const _hoisted_30 = { class: "col-span-12 lg:col-span-3" }
const _hoisted_31 = { class: "mb-2 text-black" }
const _hoisted_32 = { class: "col-span-12 lg:col-span-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 text-black" }, "E-mail", -1)
const _hoisted_34 = { class: "mb-2 text-black" }
const _hoisted_35 = {
  key: 0,
  class: "col-span-6 lg:col-span-1 flex flex-col"
}
const _hoisted_36 = ["id"]
const _hoisted_37 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_38 = { class: "col-span-12 flex mt-8 gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.$route.params.organizationId)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_4, _toDisplayString(_ctx.$t("labels.add", { pt: "Organização", en: "Organization" })), 1))
          : (_openBlock(), _createElementBlock("h4", _hoisted_5, _toDisplayString(_ctx.$t("labels.edit", { pt: "Organização", en: "Organization" })), 1)),
        _createElementVNode("form", {
          onSubmit: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.save()), ["prevent"])),
          class: "grid grid-cols-12 gap-x-5",
          autocomplete: "off"
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Nome da empresa",
                  en: "Company name",
                })), 1),
            _createVNode(_component_InputText, {
              id: "org-name-input",
              type: "text",
              modelValue: _ctx.form.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
              class: _normalizeClass(_ctx.v$.form.name.$error ? 'p-invalid' : '')
            }, null, 8, ["modelValue", "class"]),
            _createVNode(_component_Errors, {
              errors: _ctx.v$.form.name.$errors
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_InputMask, {
              mask: "99.999.999/9999-99",
              id: "org-cnpj-input",
              type: "text",
              modelValue: _ctx.form.cnpj,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.cnpj) = $event)),
              class: _normalizeClass(_ctx.v$.form.cnpj.$error ? 'p-invalid' : '')
            }, null, 8, ["modelValue", "class"]),
            _createVNode(_component_Errors, {
              errors: _ctx.v$.form.cnpj.$errors
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_InputMask, {
              mask: "99.999-999",
              id: "org-cep-input",
              type: "text",
              modelValue: _ctx.form.address.cep,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.address.cep) = $event)),
              onBlur: _ctx.getAddressByCEP,
              class: _normalizeClass(_ctx.v$.form.address.cep.$error || _ctx.cepError ? 'p-invalid' : '')
            }, null, 8, ["modelValue", "onBlur", "class"]),
            _createVNode(_component_Errors, {
              errors: _ctx.v$.form.address.cep.$errors
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("labels.generic", { pt: "Estado", en: "State" })), 1),
            _createVNode(_component_InputText, {
              id: "org-uf-input",
              type: "text",
              modelValue: _ctx.form.address.state,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.address.state) = $event)),
              class: _normalizeClass(_ctx.v$.form.address.state.$error ? 'p-invalid' : '')
            }, null, 8, ["modelValue", "class"]),
            _createVNode(_component_Errors, {
              errors: _ctx.v$.form.address.state.$errors
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("labels.generic", { pt: "Cidade", en: "City" })), 1),
            _createVNode(_component_InputText, {
              id: "org-city-input",
              type: "text",
              modelValue: _ctx.form.address.city,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.address.city) = $event)),
              class: _normalizeClass(_ctx.v$.form.address.city.$error ? 'p-invalid' : '')
            }, null, 8, ["modelValue", "class"]),
            _createVNode(_component_Errors, {
              errors: _ctx.v$.form.address.city.$errors
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("labels.generic", { pt: "Logradouro", en: "Street" })), 1),
            _createVNode(_component_InputText, {
              id: "org-street-input",
              type: "text",
              modelValue: _ctx.form.address.street,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.address.street) = $event)),
              class: _normalizeClass(_ctx.v$.form.address.street.$error ? 'p-invalid' : '')
            }, null, 8, ["modelValue", "class"]),
            _createVNode(_component_Errors, {
              errors: _ctx.v$.form.address.street.$errors
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("labels.generic", { pt: "Número", en: "Number" })), 1),
            _createVNode(_component_InputText, {
              id: "org-number-input",
              type: "text",
              modelValue: _ctx.form.address.number,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.address.number) = $event)),
              class: _normalizeClass(_ctx.v$.form.address.number.$error ? 'p-invalid' : '')
            }, null, 8, ["modelValue", "class"]),
            _createVNode(_component_Errors, {
              errors: _ctx.v$.form.address.number.$errors
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("labels.generic", { pt: "Bairro", en: "District" })), 1),
            _createVNode(_component_InputText, {
              id: "org-district-input",
              type: "text",
              modelValue: _ctx.form.address.district,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.address.district) = $event)),
              class: _normalizeClass(_ctx.v$.form.address.district.$error ? 'p-invalid' : '')
            }, null, 8, ["modelValue", "class"]),
            _createVNode(_component_Errors, {
              errors: _ctx.v$.form.address.district.$errors
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t("labels.generic", { pt: "Complemento", en: "Complement" })), 1),
            _createVNode(_component_InputText, {
              id: "org-complement-input",
              modelValue: _ctx.form.address.complement,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.address.complement) = $event)),
              type: "text"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Contatos cadastrados: ",
                  en: "Saved contacts: ",
                })) + _toDisplayString(_ctx.countContacts), 1),
            _createVNode(_component_Button, {
              id: "btn-add-contact",
              class: "btn-simple flex",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addContact()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { name: "md-add" }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Adicionar contato",
                  en: "Add contact",
                })), 1)
              ]),
              _: 1
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.contacts, (contact, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-span-12 grid grid-cols-12 gap-x-5 mt-8 gap-y-3 items-end",
              key: i
            }, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("h6", _hoisted_27, _toDisplayString(_ctx.$t("labels.generic", { pt: "Contato", en: "Contact" })) + " " + _toDisplayString(i == 0 ? "principal" : i + 1), 1)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t("labels.generic", { pt: "Setor", en: "Department" })), 1),
                _createVNode(_component_InputText, {
                  id: `org-contact-department-input-${i + 1}`,
                  modelValue: contact.department,
                  "onUpdate:modelValue": ($event: any) => ((contact.department) = $event),
                  type: "text",
                  class: _normalizeClass(
                  _ctx.v$.form.contacts.$each.$response.$errors[i].department
                    ?.length !== 0 && _ctx.v$.form.$error
                    ? 'p-invalid'
                    : ''
                )
                }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "class"]),
                (_ctx.v$.form.contacts.$dirty)
                  ? (_openBlock(), _createBlock(_component_Errors, {
                      key: 0,
                      errors: _ctx.v$.form.contacts.$each.$response.$errors[i].department
                    }, {
                      msg: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("validations.required")), 1)
                      ]),
                      _: 2
                    }, 1032, ["errors"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("labels.generic", { pt: "Nome", en: "Name" })), 1),
                _createVNode(_component_InputText, {
                  id: `org-contact-name-input-${i + 1}`,
                  modelValue: contact.name,
                  "onUpdate:modelValue": ($event: any) => ((contact.name) = $event),
                  type: "text",
                  class: _normalizeClass(
                  _ctx.v$.form.contacts.$each.$response.$errors[i].name?.length !==
                    0 && _ctx.v$.form.$error
                    ? 'p-invalid'
                    : ''
                )
                }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "class"]),
                (_ctx.v$.form.contacts.$dirty)
                  ? (_openBlock(), _createBlock(_component_Errors, {
                      key: 0,
                      errors: _ctx.v$.form.contacts.$each.$response.$errors[i].name
                    }, {
                      msg: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("validations.required")), 1)
                      ]),
                      _: 2
                    }, 1032, ["errors"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode(_component_InputText, {
                  id: `org-contact-email-input-${i + 1}`,
                  modelValue: contact.email,
                  "onUpdate:modelValue": ($event: any) => ((contact.email) = $event),
                  type: "text",
                  class: _normalizeClass(
                  _ctx.v$.form.contacts.$each.$response.$errors[i].email?.length !==
                    0 && _ctx.v$.form.$error
                    ? 'p-invalid'
                    : ''
                )
                }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "class"]),
                (_ctx.v$.form.contacts.$dirty)
                  ? (_openBlock(), _createBlock(_component_Errors, {
                      key: 0,
                      errors: _ctx.v$.form.contacts.$each.$response.$errors[i].email
                    }, {
                      msg: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("validations.required")), 1)
                      ]),
                      _: 2
                    }, 1032, ["errors"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(` ${
                i + 1 === _ctx.form.contacts.length && i > 0
                  ? 'col-span-6 lg:col-span-2'
                  : 'col-span-12 lg:col-span-3'
              }`)
              }, [
                _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t("labels.generic", { pt: "Telefone", en: "Telephone" })), 1),
                _createVNode(_component_InputMask, {
                  mask: "(99) 999999999",
                  id: `org-contact-telephone-input-${i + 1}`,
                  modelValue: contact.phone,
                  "onUpdate:modelValue": ($event: any) => ((contact.phone) = $event),
                  type: "text",
                  class: _normalizeClass(
                  _ctx.v$.form.contacts.$each.$response.$errors[i].phone?.length !==
                    0 && _ctx.v$.form.$error
                    ? 'p-invalid'
                    : ''
                )
                }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "class"]),
                (_ctx.v$.form.contacts.$dirty)
                  ? (_openBlock(), _createBlock(_component_Errors, {
                      key: 0,
                      errors: _ctx.v$.form.contacts.$each.$response.$errors[i].phone
                    }, {
                      msg: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("validations.required")), 1)
                      ]),
                      _: 2
                    }, 1032, ["errors"]))
                  : _createCommentVNode("", true)
              ], 2),
              (i + 1 === _ctx.form.contacts.length && i > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createElementVNode("button", {
                      class: "w-full p-0 h-[46px] flex justify-start items-center",
                      id: `btn-remove-contact-${i + 1}`,
                      title: "Remover contato",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.contacts.pop()))
                    }, [
                      _createVNode(_component_v_icon, {
                        class: "text-h-error-400",
                        name: "md-delete"
                      })
                    ], 8, _hoisted_36),
                    (
                  _ctx.v$.form.contacts.$each.$response.$errors[i].phone?.length !==
                    0 && _ctx.v$.form.$error
                )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_37))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_38, [
            _createVNode(_component_Button, {
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.confirmModal())),
              id: "btn-cancel-organization",
              class: "btn-outline h-10"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", { pt: "Cancelar", en: "Cancel" })), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              loading: _ctx.btnLoading,
              type: "submit",
              id: "btn-save-organization",
              class: "btn-primary h-10"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", { pt: "Salvar", en: "Save" })), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ], 32)
      ])
    ]),
    _createVNode(_component_ConfirmDialog)
  ]))
}